import {
  IonContent,
  IonHeader,
  IonLoading,
  IonPage,
  useIonRouter,
} from '@ionic/react'

import { CheckInLoyaltyHeader } from '../../check-in/components/check-in-loyalty-header'
import { ErrorCard } from '../../components/error-card'
import { LoyaltyRedemptionDetail } from '../../loyalty/components/loyalty-redemption-detail'
import { useClientLoyalty } from '../../loyalty/queries'
import { useApplyClientRewards } from '../../marketing/customer-opt-in/mutations'

import type { ApplyLoyaltyReward } from '../../loyalty/loyalty.schema'

function RotateLoyaltyInfoPage() {
  const router = useIonRouter()

  const loyalty = useClientLoyalty()
  const applyRewards = useApplyClientRewards()

  function handleApplyRewards(
    rewards: Array<ApplyLoyaltyReward>,
    options?: { redeemEarly: boolean }
  ) {
    applyRewards.mutate({ rewards, options })
  }

  function handleFinish() {
    router.push('/rotate/opt-in?loyalty=true', 'none', 'replace')
  }

  return (
    <IonPage>
      <IonHeader>
        <CheckInLoyaltyHeader onFinish={handleFinish} />
      </IonHeader>
      <IonContent>
        <>
          {loyalty.data ? (
            <LoyaltyRedemptionDetail
              data={loyalty.data}
              disabled={loyalty.isLoading}
              onApplyRewards={handleApplyRewards}
            />
          ) : loyalty.error ? (
            <ErrorCard error={loyalty.error} />
          ) : (
            <IonLoading message="Loading Rewards..." isOpen />
          )}
        </>
      </IonContent>
    </IonPage>
  )
}

export { RotateLoyaltyInfoPage }
